import SourceAbbr from './SourceAbbr';

export default SourceAbbr;
export { SourceAbbr };
